import{isGenericEventHandler as e}from"../GenericEventHandler/GenericEventHandler.js";var r=function(r){return e(r)};export{r as isCloseEventHandler};
//# sourceMappingURL=CloseEventHandler.js.map
